import _styled from "styled-components";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { observer } from "mobx-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Box, { BoxSpan } from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import Spacing from "../../Styled/Spacing";
import Text from "../../Styled/Text";
import { GLYPHS, StyledIcon } from "../../Styled/Icon";
import { scrollBars } from "../../Styled/mixins";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Frame = observer(props => {
  const theme = useTheme();
  const [t] = useTranslation();
  const [showChildren, setShowChildren] = useState(true);
  const {
    viewState
  } = props;
  return /*#__PURE__*/_jsxs(Wrapper, {
    isMapFullScreen: viewState.isMapFullScreen,
    children: [/*#__PURE__*/_jsxs(Toggle, {
      paddedVertically: true,
      paddedHorizontally: 2,
      centered: true,
      justifySpaceBetween: true,
      backgroundColor: theme.toolPrimaryColor,
      children: [/*#__PURE__*/_jsx(Title, {
        title: props.title,
        icon: GLYPHS.search
      }), /*#__PURE__*/_jsxs(_StyledBox, {
        centered: true,
        $_css: "margin-right:-5px;",
        children: [/*#__PURE__*/_jsx(ToolCloseButton, {
          viewState: viewState,
          t: t
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 4
        }), /*#__PURE__*/_jsx(RawButton, {
          onClick: () => setShowChildren(!showChildren),
          children: /*#__PURE__*/_jsx(BoxSpan, {
            paddedRatio: 1,
            centered: true,
            children: /*#__PURE__*/_jsx(StyledIcon, {
              styledWidth: "12px",
              light: true,
              glyph: showChildren ? GLYPHS.opened : GLYPHS.closed
            })
          })
        })]
      })]
    }), showChildren && props.children]
  });
});
const TOP_MARGIN = 70;
const BOTTOM_MARGIN = 100;
export const Main = styled(Text).withConfig({
  displayName: "ToolModal__Main",
  componentId: "sc-1aojx3g-0"
})(["display:flex;flex-direction:column;padding:15px;overflow-y:auto;", " border-radius:", ";background-color:", ";min-height:350px;"], _ref => {
  let {
    theme
  } = _ref;
  return scrollBars({
    theme
  });
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return "0 0 ".concat(theme.radiusXL, " ").concat(theme.radiusXL);
}, p => p.theme.darkWithOverlay);
const Wrapper = styled(Box).attrs({
  column: true,
  position: "absolute",
  styledWidth: "340px"
  // charcoalGreyBg: true
}).withConfig({
  displayName: "ToolModal__Wrapper",
  componentId: "sc-1aojx3g-1"
})(["top:", "px;left:0px;min-height:220px;max-height:calc(100vh - ", "px);margin-left:", "px;transition:margin-left 0.25s;"], TOP_MARGIN, TOP_MARGIN + BOTTOM_MARGIN, props => props.isMapFullScreen ? 16 : parseInt(props.theme.workbenchWidth, 10) + 40);
const Toggle = styled(Box).withConfig({
  displayName: "ToolModal__Toggle",
  componentId: "sc-1aojx3g-2"
})(["border-radius:", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return "".concat(theme.radiusXL, " ").concat(theme.radiusXL, " 0 0");
});
const ToolCloseButton = props => {
  return /*#__PURE__*/_jsx(RawButton, {
    onClick: () => props.viewState.closeTool(),
    children: /*#__PURE__*/_jsx(Text, {
      textLight: true,
      small: true,
      semiBold: true,
      uppercase: true,
      children: props.t("tool.exitBtnTitle")
    })
  });
};
const Title = props => {
  return /*#__PURE__*/_jsxs(Box, {
    centered: true,
    children: [/*#__PURE__*/_jsx(Box, {
      children: props.icon && /*#__PURE__*/_jsx(StyledIcon, {
        styledWidth: "20px",
        light: true,
        glyph: props.icon
      })
    }), /*#__PURE__*/_jsx(Spacing, {
      right: 1
    }), /*#__PURE__*/_jsx(TitleText, {
      textLight: true,
      semiBold: true
      // font-size is non standard with what we have so far in terria,
      // lineheight as well to hit nonstandard paddings
      ,
      styledFontSize: "17px",
      styledLineHeight: "30px",
      overflowEllipsis: true,
      overflowHide: true,
      noWrap: true,
      children: props.title
    })]
  });
};
const TitleText = styled(Text).withConfig({
  displayName: "ToolModal__TitleText",
  componentId: "sc-1aojx3g-3"
})(["flex-grow:2;max-width:220px;"]);
var _StyledBox = styled(Box).withConfig({
  displayName: "ToolModal___StyledBox",
  componentId: "sc-1aojx3g-4"
})(["", ""], p => p.$_css);